<template>
    <SelectorWrap
        :popup="popup"
        :disabled="section.disabled"
        style="width: 100%"
        ref="selectorWrap"
    >
        <template v-slot:selector>
            <div
                :class="{
                    '-focus': bodyOpened,
                    '-disabled': section.disabled || disabled
                }"
                class="section-selector"
            >
                <div
                    :id="`${section.key}-multi-selector`"
                    class="selector-container"
                    ref="container"
                >
                    <transition mode="out-in" name="fade">
                        <transition-group
                            mode="out-in"
                            name="list"
                            style="display: flex"
                            tag="div"
                            v-if="!loading && selectedValues.length != 0"
                        >
                            <div
                                :key="value.value"
                                class="display-element"
                                v-for="value in selectedValues"
                            >
                                <Emoji
                                    :value="value.icon"
                                    class="input-icon"
                                    v-if="value.icon"
                                />
                                {{ value.display }}
                            </div>
                        </transition-group>
                        <div
                            :key="'placeholder'"
                            class="display-element"
                            v-if="!loading && selectedValues.length == 0"
                        >
                            {{ $t('LABEL_EMPTY_COMMENT') }}
                        </div>
                    </transition>
                </div>
            </div>
        </template>
        <template v-slot:body>
            <div class="selector-body" ref="body">
                <ListPlaceholder
                    v-if="filteredOptions.length == 0"
                    :title="$t('LABEL_LIST_IS_EMPTY')"
                ></ListPlaceholder>
                <div class="body-rows">
                    <div
                        :key="index"
                        class="body-row"
                        @click="toggleOption(option)"
                        v-for="(option, index) in filteredOptions"
                    >
                        <div class="row-display">
                            <Emoji
                                :value="option.icon"
                                class="input-icon"
                                v-if="option.icon"
                            />
                            {{ option.display }}
                        </div>
                        <Checkbox
                            :id="`checkbox-${option.value}`"
                            :value="option.selected"
                        />
                    </div>
                </div>
                <div
                    @click="addItem(section)"
                    class="body-row -add"
                    v-if="adding"
                >
                    <div class="row-display">
                        <div class="list-action-icon">
                            <i class="material-icons">{{ 'add' }}</i>
                        </div>
                        {{ $t('BUTTON_ADD') }}
                    </div>
                </div>
            </div>
        </template>
    </SelectorWrap>
</template>
<script>
export default {
    name: 'SectionMultiSelector',
    props: {
        value: [Array, Number],
        options: Array,
        placeholder: String,
        propLoading: Boolean,
        adding: Boolean,
        section: Object,
        popup: Boolean,
        disabled: Boolean
    },
    data() {
        return {
            bodyOpened: false,
            selectedValues: [],
            bodyY: '',
            loading: true
        }
    },
    computed: {
        filteredOptions() {
            return this.options.filter(o => !o.hidden)
        }
    },
    methods: {
        addItem(section) {
            this.$emit('addItem', section)
            this.bodyOpened = false
        },
        toggleOption(option) {
            if (option.value == 'reset') {
                return this.$emit('input', ['reset'])
            }
            this.$set(option, 'selected', !option.selected)
            this.selectOption()
        },
        selectOption() {
            let value = this.options
                .map(option => {
                    if (option.selected) {
                        return option.value
                    }
                })
                .filter(option => option)
            const resetIndex = value.findIndex(v => v == 'reset')
            if (resetIndex != -1) {
                value.splice(resetIndex, 1)
            }
            this.$emit('input', value)
        },
        updateOptions() {
            this.options.forEach(option => {
                this.$set(
                    option,
                    'selected',
                    this.value != undefined &&
                        this.value != -1 &&
                        this.value.some(v => v == option.value)
                )
            })
        }
    },
    mounted() {
        this.loading = this.propLoading
        this.options.forEach(option => {
            this.$set(
                option,
                'selected',
                this.value != undefined &&
                    this.value != -1 &&
                    this.value.some(v => v == option.value)
            )
        })
        this.selectedValues = this.options
            .filter(option => option.selected == true)
            .map(option => {
                return {
                    display: option.display,
                    icon: option.icon,
                    value: option.value
                }
            })
        if (!this.propLoading) {
            this.loading = this.propLoading
        }
    },
    watch: {
        options() {
            this.updateOptions()
        },
        value() {
            this.updateOptions()
            this.selectedValues = this.options
                .filter(option => option.selected == true)
                .map(option => {
                    return {
                        display: option.display,
                        icon: option.icon,
                        value: option.value
                    }
                })
            this.loading = this.propLoading
        }
    }
}
</script>
<style lang="scss" scoped>
.list-selector {
    position: relative;
    width: 100%;
    max-width: 60vw;

    &.-error {
        color: $accent-red !important;
    }
}
.filter-click-area {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: $highest;
}
.selector-body {
    position: fixed;
    background: $background;
    z-index: $highest;
    max-height: 30vh;
    overflow: hidden;
    overflow-y: auto;
    margin-left: 0.1rem;
    border: 0.1rem solid $border-accent;
    display: flex;
    flex-direction: column;
    color: $input !important;

    @media (max-width: 768px) {
        width: calc(100vw - 2rem);
    }
}
.body-rows {
    max-height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}
.row-display {
    margin-right: 1rem;
}
.display-element {
    margin-right: 1rem;
    display: flex;
    align-items: center;
    transition: $ease;
    white-space: nowrap;
    overflow: hidden;
}
.list-enter-active,
.list-leave-active {
    transition: all 1s;
}
.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateY(30px);
}
</style>
